export const SET_FILES_FROM_DRAFT_ACTION = 'app/FilesUploader/SET_FILES_FROM_DRAFT_ACTION';
export const SET_FILES_SENDED_ACTION = 'app/FilesUploader/SET_FILES_SENDED_ACTION';
